var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrganization(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00A0CE",
    fillRule: "nonzero",
    d: "M0 0h12v12H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#FFF",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.61 4.494v.677h.776v-.677h-.777zM4.29 4.494v.677h.777v-.677H4.29zM6.963 4.494v.677h.774v-.677h-.774zM5.61 5.969v.68h.776v-.68h-.777zM4.29 5.969v.68h.777v-.68H4.29zM6.963 5.969v.68h.774v-.68h-.774z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3V3.767H3.439V9H8.555V3.767H9V3H3zm.611.767h4.773v5.079H6.78V7.68h.25c.045 0 .086-.037.086-.077 0-.041-.041-.078-.087-.078H4.95c-.044.005-.08.046-.076.086.005.04.05.073.096.069h.243v1.166H3.611V3.767zM5.385 7.68H6.61v1.166H5.385V7.68z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/organization.efc6a8ec5c82bd2875eec327207fb8b3.svg";
export { ForwardRef as ReactComponent };